export const dapRedirectCommon = Object.freeze({
  '/assets/js/wp.bundle.js': '/webPartsLoader',
})
